import { ResponsivePropsDevices, ResponsiveStyles } from '@cbhq/cds-web';

export const LEFT_NAV_WIDTH = '273px';

export const hideOnMobileConfig: Partial<Record<ResponsivePropsDevices, ResponsiveStyles>> = {
  phone: {
    display: 'none',
  },
};
